import { H5, H6 } from "@sellar-io/components";
import { ProfilePicture } from "../../../../components";

export const ProductCategoryHeader = ({
  imageUrl,
  name,
  kind,
  abv,
  onClick,
}: {
  imageUrl: string;
  name?: string | null;
  kind?: string | null;
  abv?: number | null;
  onClick?: () => void;
}) => {
  return (
    <div className={"flex items-center gap-3"} onClick={onClick}>
      <ProfilePicture logoUrl={imageUrl} name={name ?? undefined} />
      <div className={"flex flex-col"}>
        <H5>{name}</H5>
        <H6>{[kind, abv || abv === 0 ? `${abv}%` : undefined].join(" // ")}</H6>
      </div>
    </div>
  );
};
